import React, { useEffect } from 'react';
import { Input } from 'antd';
import PropTypes from 'prop-types';
import { limitNumberWithinRange } from '../../../services/util';

function InputPercentage({ min, max, onChange, value, onBlur, disabled, id }) {
  const limitedValue = limitNumberWithinRange(value, min, max);

  useEffect(() => {
    /**
     * Tratamento feito para atualizar a propriedade no componente pai com o valor correto
     * quando recebe um valor fora do limite
     */
    if (limitedValue !== value) {
      onChange(limitedValue);
    }
  }, []);

  const handleOnChange = ({ target: { value: changedValue } }) => {
    const numericValue = parseInt((changedValue || '0').replace(/\D/g, ''), 10);
    if (Number.isNaN(numericValue)) {
      onChange(value);
      return;
    }
    const changedLimitedValue = limitNumberWithinRange(numericValue, min, max);
    onChange(changedLimitedValue);
  };
  return (
    <Input
      id={id}
      data-testid={id}
      suffix="%"
      value={limitedValue}
      onChange={handleOnChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
}

InputPercentage.defaultProps = {
  onChange: (value) => value,
  onBlur: (value) => value,
  value: 0,
  min: 0,
  max: 100,
  disabled: false,
  id: null,
};

InputPercentage.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  disabled: PropTypes.bool,
  id: PropTypes.string,
};

export default InputPercentage;
